import { ReactNode } from "react";

interface AnimatedBannerProps {
  visible: boolean;
  children: ReactNode;
}

export function AnimatedBanner({ visible, children }: AnimatedBannerProps) {
  return (
    <div
      style={{
        maxHeight: visible ? 60 : 0,
        opacity: visible ? 1 : 0,
        overflow: "hidden",
        transition: "max-height 0.3s ease, opacity 0.25s ease",
      }}
    >
      {children}
    </div>
  );
}